
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


gsap.registerPlugin(ScrollTrigger);


export function initCharacterReveal(element) {
    const originalText = element.textContent.trim();
    element.textContent = '';
    element.style.position = 'relative';

    const words = originalText.split(/\s+/).filter(word => word.length > 0);

    words.forEach((word, wordIndex) => {
        const wordSpan = document.createElement('span');
        wordSpan.className = 'word';
        wordSpan.style.display = 'inline-block';
        wordSpan.style.whiteSpace = 'nowrap';

        const chars = word.split('');
        chars.forEach(char => {
            const charSpan = document.createElement('span');
            charSpan.textContent = char;
            charSpan.className = 'char';
            charSpan.style.display = 'inline-block';
            charSpan.style.opacity = '0';
            wordSpan.appendChild(charSpan);
        });

        element.appendChild(wordSpan);

        if (wordIndex < words.length - 1) {
            element.appendChild(document.createTextNode(' '));
        }
    });

    const allChars = element.querySelectorAll('.char');

    gsap.to(allChars, {
        opacity: 1,
        stagger: 0.02,
        duration: 0.03,
        ease: "none",
        scrollTrigger: {
            trigger: element,
            start: 'top 85%',
            once: true
        }
    });
}


export function initTypingAnimations() {
    const typingElements = document.querySelectorAll('.typing-text');
    typingElements.forEach(element => {
        initCharacterReveal(element);
    });
}
